import { Avatar, Button, Group, Menu, MenuDivider } from "@mantine/core";
import React from "react";
import { User } from "./models";
import {
    IconBookFilled,
    IconBrandDiscordFilled,
    IconChessFilled,
    IconChevronDown,
    IconGraphFilled,
    IconLock,
    IconLogout,
    IconMailFilled,
    IconSettingsFilled,
    IconStarFilled,
    IconUser,
} from "@tabler/icons-react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { paywall, signOut } from "./Authentication";
import { useViewportSize } from "@mantine/hooks";

interface Props {
    user: User;
}

const UserMenu: React.FC<Props> = ({ user }) => {
    const navigate = useNavigate();
    const { width } = useViewportSize();

    const handleOnSignout = async () => {
        await signOut();
        navigate(0);
    };

    const isMobile = width < 1024;

    return (
        <div className="flex items-center space-x-2 relative mr-8">
            <Menu shadow="md" width={200} withArrow closeOnEscape position="top">
                <Menu.Target>
                    {/* <a
                        className="flex justify-center items-center space-x-2 py-4 cursor-pointer col-start-2 text-inherit"
                        href={`/user/${user.username}`}
                    > */}
                    <Button
                        variant="transparent"
                        className="flex justify-center items-center space-x-2 py-4 cursor-pointer col-start-2 text-inherit"
                        p={4}
                        h="3rem"
                        color="none"
                        leftSection={
                            <Avatar radius="xl" size="sm">
                                <IconUser />
                            </Avatar>
                        }
                    >
                        <span className="hidden md:block">{user?.username}</span>
                        <div className="ml-2">
                            <IconChevronDown size={12} stroke={1.5} />
                        </div>
                    </Button>
                    {/* </a> */}
                </Menu.Target>
                <Menu.Dropdown>
                    {!user.isPremium && (
                        <>
                            <Menu.Item leftSection={<IconStarFilled size={16} />} onClick={() => navigate(`/premium`)}>
                                Go premium
                            </Menu.Item>
                            <Menu.Divider />
                        </>
                    )}
                    {isMobile && (
                        <>
                            <Menu.Item
                                leftSection={<IconChessFilled size={16} />}
                                onClick={async () => {
                                    navigate(`/`);
                                }}
                            >
                                <span>Play</span>
                            </Menu.Item>
                            <Menu.Item
                                leftSection={
                                    user.isPremium ? <IconGraphFilled size={16} /> : <IconLock color="gray" size={16} />
                                }
                                onClick={async () => {
                                    const didRedirect = await paywall(user);
                                    if (!didRedirect) {
                                        navigate(`/stats`);
                                    }
                                }}
                            >
                                {" "}
                                <Group c={user.isPremium ? "" : "dimmed"}>
                                    {" "}
                                    <span>Statistics</span>{" "}
                                </Group>{" "}
                            </Menu.Item>{" "}
                            <Menu.Item
                                leftSection={
                                    user.isPremium ? <IconBookFilled size={16} /> : <IconLock color="gray" size={16} />
                                }
                                onClick={async () => {
                                    const didRedirect = await paywall(user);
                                    if (!didRedirect) {
                                        navigate(`/positions`);
                                    }
                                }}
                            >
                                <Group c={user.isPremium ? "" : "dimmed"}>Positions </Group>{" "}
                            </Menu.Item>
                            <MenuDivider />
                        </>
                    )}
                    {user.isPremium && (
                        <Menu.Item
                            leftSection={<IconSettingsFilled size={16} />}
                            onClick={async () => {
                                const res = await axios.post(
                                    `${import.meta.env.VITE_OPENING_TRAINER_BACKEND_URL}/create-portal-session`,
                                    {
                                        lookup_key: "Preium-604af46",
                                        domain: "https://app.openingtrainer.com",
                                    },
                                    {
                                        headers: {
                                            "Content-Type": "application/json",
                                        },
                                        withCredentials: true,
                                    }
                                );
                                const url = res.data.url;
                                window.location.href = url;
                            }}
                        >
                            Manage subscription
                        </Menu.Item>
                    )}
                    <Menu.Item
                        leftSection={<IconBrandDiscordFilled size={16} />}
                        onClick={async () => {
                            window.location.href = "https://discord.gg/WNytKVEa8S";
                        }}
                    >
                        Join our Discord
                    </Menu.Item>
                    <Menu.Item
                        leftSection={<IconMailFilled size={16} />}
                        onClick={() => {
                            window.location.href = "mailto:mail@openingtrainer.com";
                        }}
                    >
                        Contact support
                    </Menu.Item>
                    {/* <div className="block md:hidden">
                        <Menu.Item
                            leftSection={<IconChessFilled size={16} />}
                            onClick={() => (window.location.href = "https://app.endgametrainer.com")}
                        >
                            Endgame trainer
                        </Menu.Item>
                    </div> */}

                    <Menu.Item leftSection={<IconLogout size={16} />} onClick={() => handleOnSignout()}>
                        Sign out
                    </Menu.Item>
                    <MenuDivider />
                    {/* <Menu.Label>Also check out</Menu.Label> */}
                    <Menu.Item
                        leftSection={<IconChessFilled color="gray" size={16} />}
                        onClick={() => (window.location.href = "https://app.endgametrainer.com")}
                    >
                        Endgame Trainer
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </div>
    );
};

export default UserMenu;
